import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { Container } from '@mui/material'
import styled from 'styled-components'

import { PUBLIC_CERTIFICATE_STATS_QUERY } from 'src/queries/PublicCertificate'
import { Query, QueryPublicCertificateArgs } from 'src/types/graphql'
import { spacing } from 'src/utils/styled'
import { GenericLoading } from 'src/components/Utils/GenericLoading/GenericLoading'
import { GenericError } from 'src/components/Utils/GenericError/GenericError'
import { CertificateStatsDisplay } from 'src/components/CertificateQuiz/CertificateStatsDisplay/CertificateStatsDisplay'

const StyledContainer = styled(Container)`
    margin-top: ${spacing(5)};
`

export function CertificateStatsRoute() {
    const { _id } = useParams<{ _id: string }>()

    const { data, loading, error } = useQuery<Pick<Query, 'publicCertificate'>, QueryPublicCertificateArgs>(
        PUBLIC_CERTIFICATE_STATS_QUERY,
        { variables: { _id: _id! } },
    )

    return (
        <StyledContainer>
            {loading && <GenericLoading />}
            {error && <GenericError title="Da ist was schiefgelaufen" message={error.message} />}
            {data?.publicCertificate && (
                <CertificateStatsDisplay certificate={data.publicCertificate} onBackToTraiwiss={() => window.close()} />
            )}
        </StyledContainer>
    )
}
